// src/components/layout/GeofenceAlerts.js
import React from 'react';
import { useApp } from '../../contexts/AppContext';

function GeofenceAlertCard({ alert, onDismiss, onViewTruck, truckColor }) {
  const time = new Date(alert.timestamp).toLocaleTimeString('en-PH', {
    hour: '2-digit', minute: '2-digit', second: '2-digit',
  });

  const distanceLabel = alert.distanceOutside >= 1000
    ? `${(alert.distanceOutside / 1000).toFixed(1)} km outside`
    : `${alert.distanceOutside} m outside`;

  return (
    <div style={{
      background: 'var(--bgModal)',
      border: '1px solid rgba(239,68,68,0.4)',
      borderLeft: '4px solid #ef4444',
      borderRadius: 12,
      padding: '14px 16px',
      backdropFilter: 'blur(16px)',
      boxShadow: '0 8px 32px rgba(0,0,0,0.4)',
      animation: 'slideInRight 0.3s ease',
      minWidth: 320,
      maxWidth: 380,
    }}>
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
        <div style={{ width: 38, height: 38, borderRadius: 10, background: 'rgba(239,68,68,0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18, flexShrink: 0 }}>
          🚨
        </div>

        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 4 }}>
            <div style={{ fontFamily: 'Syne, sans-serif', fontWeight: 700, fontSize: 14, color: '#f87171' }}>
              Geofence Breach
            </div>
            <div style={{ fontSize: 10, color: 'var(--textFaint)' }}>{time}</div>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
            <div style={{ width: 8, height: 8, borderRadius: '50%', background: truckColor || '#ef4444', flexShrink: 0 }} />
            <span style={{ fontSize: 13, fontWeight: 700, color: 'var(--textPrimary)', fontFamily: 'Syne, sans-serif' }}>
              {alert.plateNumber}
            </span>
            <span style={{ fontSize: 11, color: 'var(--textMuted)' }}>· {alert.driver}</span>
          </div>

          <div style={{ fontSize: 12, color: 'var(--textSecondary)', marginBottom: 3 }}>
            Left <strong style={{ color: 'var(--textPrimary)' }}>{alert.geofenceName}</strong>
          </div>

          <div style={{ fontSize: 11, color: '#f87171', marginBottom: 8 }}>
            📍 {distanceLabel} · {alert.address}
          </div>

          <button
            onClick={() => onViewTruck(alert.truckId)}
            style={{
              background: 'rgba(59,130,246,0.15)', border: '1px solid rgba(59,130,246,0.35)',
              borderRadius: 7, color: '#60a5fa', fontSize: 12, fontWeight: 700,
              padding: '7px 12px', cursor: 'pointer', width: '100%',
            }}
          >
            🗺️ View Truck on Map
          </button>
        </div>

        <button onClick={() => onDismiss(alert.id)} style={{ background: 'none', border: '1px solid var(--border)', borderRadius: 6, color: 'var(--textFaint)', cursor: 'pointer', width: 24, height: 24, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 10, flexShrink: 0 }}>✕</button>
      </div>
    </div>
  );
}

export default function GeofenceAlerts() {
  const { geofenceAlerts, dismissGeofenceAlert, trucks, navigateToTruck } = useApp();

  if (!geofenceAlerts || geofenceAlerts.length === 0) return null;

  const handleViewTruck = (truckId) => {
    navigateToTruck(truckId);
  };

  return (
    <div style={{
      position: 'fixed',
      bottom: 24,
      left: 24,
      zIndex: 9997,
      display: 'flex',
      flexDirection: 'column',
      gap: 10,
      alignItems: 'flex-start',
    }}>
      {geofenceAlerts.map(alert => {
        const truck = trucks.find(t => t.id === alert.truckId);
        return (
          <GeofenceAlertCard
            key={alert.id}
            alert={alert}
            onDismiss={dismissGeofenceAlert}
            onViewTruck={handleViewTruck}
            truckColor={truck?.color}
          />
        );
      })}
    </div>
  );
}
